/* eslint-disable prettier/prettier, linebreak-style, indent */
/* global jQuery */
class RelatedPosts {
  constructor() {
    this.selectors = {
      slider: '.js-related-posts__posts',
    };

    this.DOM = {
      sliders: document.querySelectorAll(this.selectors.slider),
    };

    this.classes = {};

    window.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    if (this.DOM.sliders.length) {
      this.DOM.sliders.forEach((slider) => {
        jQuery(slider).slick({
          slidesToShow: 1,
          arrows: false,
          dots: false,
          autoplay: false,
          infinite: false,
          mobileFirst: true,
          centerMode: true,
          centerPadding: '18px',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                centerMode: false,
              }
            },
            {
              breakpoint: 1280,
              settings: "unslick"
            }
          ]
        });
      });
    }
  }
}

export default new RelatedPosts();
